import type { RouteObject } from 'react-router';
import App from '../App';
import ContentScreen from '../screens/ContentScreen';
import { CONTENT_PAGES } from '../../utils/websiteSsr/content';
import AuthScreen from '../screens/AuthScreen';
import CartScreen from '../screens/CartScreen';
import CatalogScreen from '../screens/CatalogScreen';
import CategoryScreen from '../screens/CategoryScreen';
import ManufacturerScreen from '../screens/ManufacturerScreen';
import NotFoundScreen from '../screens/NotFoundScreen';
import OrderSuccessScreen from '../screens/OrderSuccess';
import OrdersScreen from '../screens/OrdersScreen';
import ProfileScreen from '../screens/ProfileScreen';
import ProductScreen from '../screens/ProductScreen';

// Route objects are framework-agnostic and can be reused by browser or server routers.
export const websiteRoutes: RouteObject[] = [
  {
    path: '/',
    element: <App />,
    children: [
      { index: true, element: <ContentScreen pageKey="home" /> },
      { path: 'catalog', element: <CatalogScreen /> },
      ...CONTENT_PAGES.filter((page) => page.key !== 'home').map((page) => ({
        path: page.path.slice(1),
        element: <ContentScreen pageKey={page.key} />,
      })),
      { path: 'category/:categorySlug', element: <CategoryScreen /> },
      { path: 'manufacturer/:manufacturerSlug', element: <ManufacturerScreen /> },
      { path: 'product/:productSlug', element: <ProductScreen /> },
      { path: 'cart', element: <CartScreen /> },
      { path: 'order-success', element: <OrderSuccessScreen /> },
      { path: 'orders', element: <OrdersScreen /> },
      { path: 'login', element: <AuthScreen /> },
      { path: 'profile', element: <ProfileScreen /> },
      { path: '*', element: <NotFoundScreen /> },
    ],
  },
];
